import { useTranslation } from "react-i18next";
import { getAssignmentEnrolleeNamePresentation } from "@/components/lms/enrolmentAssignmentTargetSelection";
import styles from "@/components/lms/assignmentEnrolleeNames.module.css";

interface Props {
  assignment: any;
  maxVisible?: number;
}

export default function AssignmentEnrolleeNames({
  assignment,
  maxVisible = 5,
}: Props) {
  const { t } = useTranslation();
  const { visibleNames, remainingCount } = getAssignmentEnrolleeNamePresentation(
    assignment,
    maxVisible,
  );

  if (visibleNames.length === 0) {
    return <>-</>;
  }

  return (
    <div className={styles.wrapper}>
      {visibleNames.map((name, index) => {
        const isLastVisibleName = index === visibleNames.length - 1;
        const showTrailingComma = !isLastVisibleName || remainingCount > 0;

        return (
          <div key={`${name}-${index}`}>
            {showTrailingComma ? `${name},` : name}
          </div>
        );
      })}
      {remainingCount > 0 && (
        <div className={styles.remainingCount}>
          {t("enrollees_additional_count", { count: remainingCount })}
        </div>
      )}
    </div>
  );
}
